import { Base } from './_base';

export class TimeBackend extends Base {
  constructor(item) {
    super(item);
  }
}
